<template>
  <div class="current-living-condition-show-component" v-bind:class={loaded}>
    <div class="panel panel-stretch panel-default">
      <div class="panel-heading">Woonsituatie van {{ firstName }}</div>
      <table class="table table-striped table-fixed" v-if="loaded">
        <tbody v-if="hasCurrentLivingCondition">
        <tr>
          <td><strong>Woning</strong></td>
          <td></td>
          <td><strong>Energie</strong></td>
          <td></td>
        </tr>
        <tr>
          <td>Adres</td>
          <td>{{ `${property.street} ${property.formatted_number}` }}</td>
          <td>{{ getEnergyLabelLabel() }}</td>
          <td>{{ getEnergyLabelValue() }}</td>
        </tr>
        <tr>
          <td>Postcode & woonplaats</td>
          <td>{{ `${property.postal_code} ${property.city}` }}</td>
          <td v-if="hasEnergyLabel()">Energielabel geldig tot</td>
            <td v-else></td>
          <td v-if="hasEnergyLabel()">{{ getEnergyLabelEndDate() }}</td>
            <td v-else></td>
        </tr>
        <tr>
          <td>Type woonhuis</td>
          <td>{{ property.type_description }}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Bouwjaar</td>
          <td>{{ property.construction_year }}</td>
          <td><strong>Oorspronkelijk</strong></td>
          <td><strong>Bedrag</strong></td>
        </tr>
        <tr>
          <td>Woonoppervlakte</td>
          <td>{{ property.surface | toSurface }}</td>
          <td>Koopsom</td>
          <td>{{ getPurchasePrice | toCurrency }}</td>
        </tr>
        <tr>
          <td>Perceeloppervlakte</td>
          <td>{{ property.plot_size | toSurface }}</td>
          <td>Marktwaarde origineel</td>
          <td>{{ currentLivingCondition.market_value_original | toCurrency }}</td>
        </tr>
        <tr>
          <td>Kadastrale aanduiding</td>
          <td>{{ property.cadastral_designation }}</td>
          <td>Hypotheek origineel</td>
          <td>{{ currentLivingCondition.original_mortgage_amount | toCurrency }}</td>
        </tr>
        <tr>
          <td>Kadastrale object id</td>
          <td>{{ property.cadastral_number }}</td>
          <td>Schuld-marktwaardeverhouding</td>
          <td v-if="currentLivingCondition.debt_market_value_ratio_original !== 0" >{{ (currentLivingCondition.debt_market_value_ratio_original) | toPercentage(0) }}</td>
          <td v-else>-</td>
        </tr>
        <tr>
          <td>Herbouwwaarde</td>
          <td>{{ property.rebuild_value | toCurrency(0) }}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>&nbsp</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td><strong>Wonen</strong></td>
          <td></td>
          <td><strong>Huidig</strong></td>
          <td><strong>Bedrag</strong></td>
        </tr>
        <tr>
          <td>Woonsituatie</td>
          <td>{{ formatCurrentLivingConditionType(currentLivingCondition.type) }}</td>
          <td>Marktwaarde (laag)</td>
          <td>{{ property.value_low | toCurrency }}</td>
        </tr>
        <tr>
          <td>Woont samen</td>
          <td>{{ customerProperty.living_together | toYesNo }}</td>
          <td>Marktwaarde (hoog)</td>
          <td>{{ property.value_high | toCurrency }}</td>
        </tr>
        <tr>
          <td>Percentage-eigendom</td>
          <td>{{ customerProperty.percentage_owner | toPercentage(0) }}</td>
          <td>Hypotheek</td>
          <td>{{ currentLivingCondition.remaining_mortgage_amount | toCurrency }}</td>
        </tr>
        <tr>
          <td>Datum eigendomsoverdracht</td>
          <td>{{ customerProperty.transaction_date | toDate }}</td>
          <td>Schuld-marktwaardeverhouding
            <a-popover title="Volgorde gebruikte marktwaarde" placement="topLeft">
              <template slot="content">
                <ol>
                  <li>Marktwaarde (hoog)</li>
                  <li>Marktwaarde geschat</li>
                  <li>WOZ-waarde</li>
                  <li>Marktwaarde origineel</li>
                  <li>Marktwaarde (laag)</li>
                </ol>
              </template>
              <tooltip-text-outline-icon/>
            </a-popover>
          </td>
          <td v-if="currentLivingCondition.debt_market_value_ratio !== 0" >{{ (currentLivingCondition.debt_market_value_ratio) | toPercentage(0) }}</td>
          <td v-else>-</td>
        </tr>
        <tr>
          <td>Erfpachtcanon</td>
          <td>{{ property.leasehold_canon | toCurrency }}</td>
          <td>Bruto maandlast (hypotheken)</td>
          <td>{{ currentLivingCondition.total_monthly_amount | toCurrency }}</td>
        </tr>
        <tr>
          <td>Doel van woning</td>
          <td>{{ parsedPurpose }}</td>
          <td>Marktwaarde geschat</td>
          <td>{{ property.market_value | toCurrency }}</td>
        </tr>
        <tr>
          <td>Status</td>
          <td>{{ property.purpose_status}}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Gebruik</td>
          <td>{{ property.purpose}}</td>
          <td></td>
          <td></td>
        </tr>
        <template v-if="sellOrSoldPurpose">
          <tr>
            <td>Verkoopprijs</td>
            <td colspan="3">{{ currentLivingCondition.sale_price | toCurrency }}</td>
          </tr>
          <tr>
            <td>Verkoopkosten</td>
            <td colspan="3">{{ currentLivingCondition.sale_costs | toCurrency }}</td>
          </tr>
          <tr>
            <td>Leveringsdatum</td>
            <td colspan="3">{{ currentLivingCondition.date_of_delivery | toDate }}</td>
          </tr>
        </template>
        <tr>
          <td colspan="4">&nbsp;</td>
        </tr>
        <template v-if="showRentalFields">
          <tr>
            <td><strong>Woonlasten</strong></td>
            <td><strong>Netto per maand</strong></td>
            <td><strong>Gemeentelijke vaste lasten</strong></td>
            <td><strong>Bedrag</strong></td>
          </tr>
          <tr>
            <td>Kale huur p/m</td>
            <td>{{ currentLivingCondition.basic_rent | toCurrency }}</td>
            <td>WOZ-waarde woning</td>
            <td>{{ property.real_estate_value | toCurrency }}</td>
          </tr>
          <tr>
            <td>Servicekosten p/m</td>
            <td>{{ currentLivingCondition.service_costs | toCurrency }}</td>
            <td>Overige kosten p/m</td>
            <td>{{ currentLivingCondition.other_costs | toCurrency }}</td>
          </tr>
          <tr>
            <td>Jaarlijkse huurstijging</td>
            <td>{{ currentLivingCondition.rental_increase_rate | toPercentage }}</td>
            <td>Datum huurovereenkomst</td>
            <td>{{ currentLivingCondition.since | toDate }}</td>
          </tr>
          <tr>
            <td>Afvalstoffenheffing per jaar</td>
            <td>{{ property.waste_charges | toCurrency }}</td>
            <td>OZB tarief</td>
            <td>{{ property.property_tax_rate | toPercentage }}</td>
          </tr>
        </template>
        <template v-if="showResidentFields">
          <tr>
            <td><strong>Woonlasten</strong></td>
            <td><strong>Netto per maand</strong></td>
            <td colspan="2"></td>

          </tr>
          <tr>
            <td>Kosten inwonend p/m</td>
            <td>{{ currentLivingCondition.rental_costs | toCurrency }}</td>
            <td colspan="2"></td>
          </tr>
          <tr>
            <td>Overige kosten p/m</td>
            <td>{{ currentLivingCondition.other_costs | toCurrency }}</td>
            <td colspan="2"></td>
          </tr>
        </template>
        <template v-if="showPropertyFields">
          <tr>
            <td><strong>Partijen</strong></td>
            <td><strong>Naam</strong></td>
            <td><strong>Gemeentelijke vaste lasten</strong></td>
            <td><strong>Bedrag</strong></td>
          </tr>
          <tr>
            <td>Notaris</td>
            <td>
              <span v-if="hasFirstMortgage">
                {{ firstMortgage.notary_name }}
              </span>
            </td>
            <td>WOZ-waarde woning</td>
            <td>{{ property.real_estate_value | toCurrency }}</td>
          </tr>
          <tr>
            <td>Verkopend makelaar</td>
            <td>
              <span v-if="hasFirstMortgage">
                {{ firstMortgage.selling_broker_name }}
              </span>
            </td>
            <td>Afvalstoffenheffing per jaar</td>
            <td>{{ property.waste_charges | toCurrency }}</td>
          </tr>
          <tr>
            <td>Aankopend makelaar</td>
            <td>
              <span v-if="hasFirstMortgage">
                {{ firstMortgage.purchasing_broker_name }}
              </span>
            </td>
            <td>Rioolheffing per jaar</td>
            <td>{{ property.sewage_charges | toCurrency }}</td>
          </tr>
          <tr>
            <td>Taxateur</td>
            <td>
              <span v-if="hasFirstMortgage">
                {{ firstMortgage.appraiser_name }}
              </span>
            </td>
            <td>OZB tarief</td>
            <td>{{ property.property_tax_rate | toPercentage }}</td>
          </tr>
          <tr>
            <td>Bouwkundig ingenieur</td>
            <td>
              <span v-if="hasFirstMortgage">
                {{ firstMortgage.structural_engineer_name }}
              </span>
            </td>
            <td>OZB belasting</td>
            <td>{{ ((property.property_tax_rate || 0) * (property.real_estate_value || 0)) / 100 | toCurrency }}
            </td>
          </tr>
        </template>
        </tbody>
        <tbody v-else>
        <tr>
          <td>
            Geen huidige woonsituatie bekend
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="hasMortgageProperties" class="panel panel-stretch panel-default">
      <div class="panel-heading">
        Gekoppelde hypotheken
      </div>
      <table class="table table-striped table-bordered">
        <thead>
        <tr>
          <th class="compact">
            Hypotheeknummer
          </th>
          <th class="compact">Reden</th>
          <th class="compact">Passeerdatum</th>
          <th class="compact">Geldverstrekker</th>
          <th class="compact">Onderpanden</th>
          <th class="compact">Hoofdsom en Restant</th>
          <th class="compact">Labels</th>
        </tr>
        </thead>
        <tbody>
        <mortgage-row-component v-for="mortgageProperty in mortgageProperties"
                                v-bind:key="mortgageProperty.id"
                                v-bind:mortgage-id="mortgageProperty.mortgage_id">
        </mortgage-row-component>
        </tbody>
      </table>
      <div class="panel-body" v-if="false">
        <show-mortgage-property-component v-for="mortgageProperty in mortgageProperties"
                                          v-bind:key="mortgageProperty.id"
                                          v-bind:mortgage-property="mortgageProperty"
                                          v-bind:show-mortgage-information="true"
                                          v-bind:show-property="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import currentLivingConditionApi from "~/api/customer_current_living_condition"
import mortgageRowComponent from "~/modules/mortgage/components/RowComponent"
import showMortgagePropertyComponent from "~/modules/mortgage_property/components/ShowComponent"
import {OccupancyTypeEnum, PropertyPurposeEnum} from '../../../enums';
import DateFormatEnum from "~/enums/DateFormatEnum";

export default {
  name: "ShowCustomerCurrentLivingConditionComponent",
  components: {
    mortgageRowComponent,
    showMortgagePropertyComponent
  },
  props: {
    customer: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      loaded: false,
      mortgages: null,
      property: null,
      customerProperty: null,
      mortgageProperties: [],
      currentLivingCondition: null,
      propertyTypeList: {
        'single_family_house': 'Eengezinswoning',
        'single_family_house_with_garage': 'Eengezinswoning met garage',
        'flat_apartment': 'Flat appartement',
        'flat_apartment_garage': 'Flat appartement garage',
        'shop_residence': 'Winkelwoonhuis',
        'residential_home_business_space': 'Woonhuis bedrijfsruimte',
        'store': 'Winkel',
        'business_premises': 'Bedrijfspand',
        'recreation_house': 'Recreatiewoning',
        'farm': 'Boerderij',
        'business_collateral': 'Zakelijkonderpand',
        'ground': 'Grond',
        'garage': 'Garage',
        'building_plot': 'Bouwkavel',
        'boat_house': 'Woonschip',
        'pleasure_craft': 'Pleziervaartuig',
      },
      purposeList: {
        'keep_living': 'Blijven wonen',
        'sell': 'Verkopen',
        'sold': 'Verkocht'
      }
    }
  },
  computed: {
    getPurchasePrice() {
      return this.property.purchase_price ?? this.currentLivingCondition.purchase_price;
    },
    propertyPurpose() {
      return this.currentLivingCondition.property_purpose;
    },
    sellOrSoldPurpose() {
      return this.propertyPurpose === PropertyPurposeEnum.SELL || this.propertyPurpose === PropertyPurposeEnum.SOLD;
    },
    firstName() {
      return this.customer.first_name || this.customer.firstName;
    },
    hasCustomerProperty() {
      return this.customerProperty !== null;
    },
    hasFirstMortgage() {
      return this.firstMortgage !== null;
    },
    firstMortgage() {
      if (this.mortgages !== null && this.mortgages.length > 0) {
        return this.mortgages[0];
      }

      return null;
    },
    parsedPurpose() {
      return this.purposeList[this.customerProperty.property_purpose] || ''

    },
    parsedOwnersAssociation() {
      return this.customerCurrentLivingCondition.owners_association > 0 ? 'Ja' : 'Nee'
    },
    formattedServiceCosts() {
      // TODO: format for valuta
      return this.customerCurrentLivingCondition.service_costs ? '€ ' + this.customerCurrentLivingCondition.service_costs : '';
    },
    hasCurrentLivingCondition() {
      return this.currentLivingCondition !== null;
    },
    hasMortgageProperties() {
      return this.mortgageProperties !== null && this.mortgageProperties.length > 0;
    },
    showRentalFields() {
      if (this.hasCurrentLivingCondition) {
        return this.currentLivingCondition.type === OccupancyTypeEnum.RENTAL;
      }
      return false;
    },
    showResidentFields() {
      if (this.hasCurrentLivingCondition) {
        return this.currentLivingCondition.type === OccupancyTypeEnum.RESIDENT;
      }
      return false;
    },
    showPropertyFields() {
      if (this.hasCurrentLivingCondition) {
        return this.currentLivingCondition.type === OccupancyTypeEnum.PROPERTY;
      }
      return false;
    },
  },
  mounted() {
    currentLivingConditionApi.findByCustomer(this.customer.id, [
      'mortgages',
      'customer_property',
      'customer_property.property',
      'customer_property.property.mortgage_properties',
      'customer_property.property.mortgage_properties.mortgage',
      'customer_property.property.mortgage_properties.property',
    ]).then(response => {
      this.currentLivingCondition = response.data;
      this.mortgages = this.currentLivingCondition.mortgages.data;
      this.customerProperty = this.currentLivingCondition.customer_property.data;
      this.property = this.customerProperty.property.data;
      this.mortgageProperties = this.property.mortgage_properties.data.filter(mortgageProperty => {
        return mortgageProperty.mortgage.data.customer_id === this.customer.id;
      });
    }).finally(() => {
      this.loaded = true;
    })
  },
  methods: {
    formatDate(date) {
      if (date !== null && typeof date !== 'undefined' && date !== '') {
        return moment(date, moment.ISO_8601).format('D/MM/YYYY');
      }
    },
    formatCurrentLivingConditionType(type) {
      switch(type) {
        case OccupancyTypeEnum.RENTAL:
          return 'Huurwoning';
        case OccupancyTypeEnum.RESIDENT:
          return 'Inwonend';
        case OccupancyTypeEnum.PROPERTY:
          return 'Koopwoning';
        default:
          return 'Onbekend';
      }
    },
    hasEnergyLabel() {
        return this.property.energy_label !== null && typeof this.property.energy_label !== 'undefined' && this.property.energy_label !== ''
    },
    hasEstimatedEnergyLabel() {
      return this.property.estimated_energy_label !== null && typeof this.property.estimated_energy_label !== 'undefined' && this.property.estimated_energy_label !== ''
    },
    hasEnergyLabelEndDate() {
      return this.property.energy_label_end_date !== null && typeof this.property.energy_label_end_date !== 'undefined' && this.property.energy_label_end_date !== ''
    },
    getEnergyLabelLabel() {
      if (this.hasEnergyLabel()) {
        return 'Energielabel'
      }
      if (this.hasEstimatedEnergyLabel()) {
        return 'Geschat energielabel'
      }

      return 'Energielabel'
    },
    getEnergyLabelValue() {
      if (this.hasEnergyLabel()) {
        return this.property.energy_label
      }
      if (this.hasEstimatedEnergyLabel()) {
        this.property.estimated_energy_label
      }

      return '-'
    },
    getEnergyLabelEndDate()
    {
      return this.property.energy_label_end_date? moment(this.property.energy_label_end_date).format(DateFormatEnum.DISPLAY_DATE) : '-'
    }
  },
}
</script>
<style scoped>
</style>
